import DOMPurify from 'dompurify';
import type React from 'react';
import type { FC } from 'react';
import styles from '@/components/AnimatedText/AnimatedText.module.css';
import { cn } from '@/utils';

type PlaceInputPropsType = {
	label: string;
	className?: string;
	ref?: React.Ref<HTMLSpanElement>;
};

const AnimatedText: FC<PlaceInputPropsType> = ({ className, label, ref }) => {
	return (
		<span
			className={cn(styles.fadeText, className)}
			dangerouslySetInnerHTML={{
				__html: DOMPurify.sanitize(label)
			}}
			ref={ref}
		/>
	);
};

export default AnimatedText;
